import {Injectable} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {from, Observable} from "rxjs";
import {PointChecklistModalComponent} from "./point-checklist-modal.component";
import {SrmPointChecklist} from "../../../../generated-model/model";

@Injectable({providedIn: 'root'})
export class PointChecklistModalService {


  constructor(private modalService: NgbModal) {
  }

  open(checklist: SrmPointChecklist[]): Observable<boolean> {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(PointChecklistModalComponent, {size: 'xl'});
    modalRef.componentInstance.checklist = checklist;
    return from(modalRef.result)
  }
}
